import { render, staticRenderFns } from "./FaqSearchBox.vue?vue&type=template&id=52ccbb96&scoped=true&"
import script from "./FaqSearchBox.vue?vue&type=script&lang=js&"
export * from "./FaqSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./FaqSearchBox.vue?vue&type=style&index=0&id=52ccbb96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ccbb96",
  null
  
)

export default component.exports